var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"sprite",attrs:{"height":_vm.radius * 2,"width":_vm.radius * 2}})
}
var staticRenderFns = []

export { render, staticRenderFns }